<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-flex sm12 lg10 xl8 p-0>
            <!--
            <v-breadcrumbs :items="breadCrumbs">
                <template v-slot:divider>
                    <v-icon>forward</v-icon>
                </template>
            </v-breadcrumbs>
            -->
            <v-card class="tutorials-card">
                <v-card-title><h2>{{ $t("tutorials") }}</h2></v-card-title>
                <v-container fluid grid-list-md>
                    <v-flex>
                        <v-card class="f-left ml-2 mr-4 mb-4">
                            <div>
                                <iframe v-if="$vuetify.breakpoint.lgAndUp" width="560" height="315" src="https://rutube.ru/play/embed/95c7715cf41efcb7766b514e2a9f2620/" frameBorder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
                                <iframe v-else width="320" height="180" src="https://rutube.ru/play/embed/95c7715cf41efcb7766b514e2a9f2620/" frameBorder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
                            </div>
                        </v-card>

                        <div v-if="$i18n.locale == 'ru'">
                            <h3 class="text-xs-center">Запись образовательного вебинара</h3>
                            <p class="pr-0">
                                Всем специалистам лесопильных предприятий необходимо эффективно использовать пиловочник, чтобы получить максимально возможный полезный выход готовой продукции и минимальный объём отходов.
                                Именно по этим критериям формируются схемы раскроя сырья (поставы), и составление этих схем должно выполняться без ошибок.
                                Оптимизация процесса распиловки брёвен должна быть простой во внедрении, понятной пользователю, обладать дружественным интерфейсом и проводить все расчёты корректно и быстро.
                                Для этого «АВТОМАТИКА-ВЕКТОР» разработала веб-сервис SawMillLab, о котором мы рассказывали на нашем совместном с Ассоциацией ЛЕСТЕХ вебинаре «SawMillLab. Проектирование оптимального постава. Объёмный или стоимостный выход?»
                            </p>
                        </div>
                        <div v-else>
                            <h3 class="text-xs-center">Educational Webinar Recording</h3>
                            <p class="pr-0">
                                All sawmill specialists need to use sawlogs effectively to achieve the highest possible yield of finished products and minimize waste.
                                Sawing patterns are developed based on these specific criteria, and designing these schemes must be done without errors.
                                Optimizing the log sawing process should be simple to implement, intuitive for the user, feature a friendly interface, and perform all calculations correctly and quickly.
                                To meet these needs, we developed the SawMillLab web service, which we presented during our webinar titled "SawMillLab. Designing the Optimal Pattern. Volumetric or Value-Based Yield?"
                            </p>
                        </div>

                        <div class="f-clear" />
                        <v-divider></v-divider>

                        <v-card class="f-left ml-2 mr-4 mt-4 mb-4">
                            <div>
                                <iframe v-if="$vuetify.breakpoint.lgAndUp" width="560" height="315" src="https://rutube.ru/play/embed/21a6dadc56b20344a3a207516edc7090?p=bTYHsleEO8FE0I0PptGxBA" frameBorder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
                                <iframe v-else width="320" height="180" src="https://rutube.ru/play/embed/21a6dadc56b20344a3a207516edc7090?p=bTYHsleEO8FE0I0PptGxBA" frameBorder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
                            </div>
                        </v-card>

                        <div v-if="$i18n.locale == 'ru'">
                            <h3 class="text-xs-center">Создание и настройка линии обработки пиломатериалов</h3>
                            <p class="pr-0">
                                Для успешного поиска оптимальных поставов первым делом необходимо сформировать вашу линию обработки пиломатериалов.
                                Оборудование можно редактировать, а также создавать комбинации линий с разными параметрами.
                                Видео без звукового сопровождения.
                            </p>
                        </div>
                        <div v-else>
                            <h3 class="text-xs-center">Creating and Configuring a Lumber Processing Line</h3>
                            <p class="pr-0">
                                To successfully find optimal sawing patterns, the first step is to configure your lumber processing line.
                                The equipment can be edited, and you can create various line combinations with different parameters.
                                Video without audio.
                            </p>
                        </div>

                        <div class="f-clear" />
                        <v-divider></v-divider>

                        <v-card class="f-left ml-2 mr-4 mt-4 mb-4">
                            <div>
                                <iframe v-if="$vuetify.breakpoint.lgAndUp" width="560" height="315" src="https://rutube.ru/play/embed/68d90613c2cce8ab1d825be2713be670?p=7xvnsP1FmrebDPZ2f-g1jg" frameBorder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
                                <iframe v-else width="320" height="180" src="https://rutube.ru/play/embed/68d90613c2cce8ab1d825be2713be670?p=7xvnsP1FmrebDPZ2f-g1jg" frameBorder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
                            </div>
                        </v-card>

                        <div v-if="$i18n.locale == 'ru'">
                            <h3 class="text-xs-center">Расчёт оптимальных поставов</h3>
                            <p class="pr-0">
                                На основе заданной конфигурации линии обработки и параметров требуемых пиломатериалов программа подберёт поставы, которые могут быть реализованы на выбранном оборудовании и обеспечивают максимальный выход либо максимальную стоимость продукции.
                                Кроме этого, алгоритм учитывает допустимый обзол пиломатериалов, бессердцевинную доску, кривизну и эллипсность бревна.
                                <br>
                                Вы можете изменять результаты расчета в удобном редакторе.
                                Старые задачи всегда можно подгрузить из истории.
                                А самый оптимальный раскрой можно напечатать в форме отчета или сохранить в PDF файле.
                                Видео без звукового сопровождения.
                            </p>
                        </div>
                        <div v-else>
                            <h3 class="text-xs-center">Calculation of Optimal Sawing Patterns</h3>
                            <p class="pr-0">
                                Based on the specified processing line configuration and the parameters of the required lumber, the program will select sawing patterns (postavs) that can be implemented on the chosen equipment and provide the maximum yield or maximum product value.
                                In addition, the algorithm takes into account the allowable wane of the lumber, heart-free boards, log curvature, and ovality.
                                <br>
                                You can modify the calculation results in a user-friendly editor.
                                Previous tasks can always be reloaded from the history.
                                The most optimal layout can be printed as a report or saved as a PDF file.
                                Video without audio.
                            </p>
                        </div>

                        <div class="f-clear" />
                        <v-divider></v-divider>

                        <v-card class="f-left ml-2 mr-4 mt-4 mb-4">
                            <div>
                                <iframe v-if="$vuetify.breakpoint.lgAndUp" width="560" height="315" src="https://rutube.ru/play/embed/7c38af60fc5a22a089e43aa34b10c188?p=glzlYaL_me6qkeWZuRtCvw" frameBorder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
                                <iframe v-else width="320" height="180" src="https://rutube.ru/play/embed/7c38af60fc5a22a089e43aa34b10c188?p=glzlYaL_me6qkeWZuRtCvw" frameBorder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
                            </div>
                        </v-card>

                        <div v-if="$i18n.locale == 'ru'">
                            <h3 class="text-xs-center">Библиотека поставов и ручное создание раскроев</h3>
                            <p class="pr-0">
                                Поставы можно создавать вручную и в любой момент рассчитать его параметры или подредактировать существующий раскрой.
                                Все результаты оптимизации и поставы хранятся в базе данных, а система многопользовательского доступа позволяет работать над данными совместно с разных компьютеров.<br>
                                Создайте свой постав и посмотрите, насколько выгодно его пилить!
                                Видео без звукового сопровождения.
                            </p>
                        </div>
                        <div v-else>
                            <h3 class="text-xs-center">Pattern Library and Manual Layout Creation</h3>
                            <p class="pr-0">
                                Sawing patterns can be created manually, allowing you to calculate their parameters or edit an existing layout at any time.
                                All optimization results and patterns are stored in a database, and the multi-user access system enables collaborative work on data from different computers.<br>
                                Create your own pattern and see how profitable it is to saw!
                                Video without audio.
                            </p>
                        </div>

                        <div class="f-clear" />
                        <v-divider></v-divider>

                        <v-card class="f-left ml-2 mr-4 mt-4 mb-4">
                            <div>
                                <iframe v-if="$vuetify.breakpoint.lgAndUp" width="560" height="315" src="https://rutube.ru/play/embed/b7f87aaf9e157ec53fe29dd8ccdbeeeb?p=stN4ELp8HXiit5yertS4BA" frameBorder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
                                <iframe v-else width="320" height="180" src="https://rutube.ru/play/embed/b7f87aaf9e157ec53fe29dd8ccdbeeeb?p=stN4ELp8HXiit5yertS4BA" frameBorder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
                            </div>
                        </v-card>

                        <div v-if="$i18n.locale == 'ru'">
                            <h3 class="text-xs-center">Поиск оптимальных диаметров пиловочника</h3>
                            <p class="pr-0">
                                Сервис поможет Вам с поиском оптимальных параметров пиловочника.
                                Выберите интересующий вас постав, задайте параметры брёвен, и система рассчитает наилучший диаметр и диапазон оптимальных диаметров для эффективного пиления.
                                Видео без звукового сопровождения.
                            </p>
                        </div>
                        <div v-else>
                            <h3 class="text-xs-center">Finding Optimal Sawlog Diameters</h3>
                            <p class="pr-0">
                                The service will assist you in finding the optimal parameters for your sawlogs.
                                Select the sawing pattern (postav) you are interested in, specify the log parameters, and the system will calculate the best diameter and the range of optimal diameters for efficient sawing.
                                Video without audio.
                            </p>
                        </div>
                        <div class="f-clear" />

                    </v-flex>
                </v-container>
            </v-card>
        </v-flex>
        <!-- <v-fab-transition>
            <v-btn
                v-show="scrolled"
                color="teal darken-1"
                @click="scrollToTop"
                dark
                fixed
                bottom
                right
                fab
                class="mb-4"
            >
                <v-icon>keyboard_arrow_up</v-icon>
            </v-btn>
        </v-fab-transition> -->
    </v-layout>
</template>

<script>
    export default {
        name: "TutorialsVue",

        data () {
            return {
                visible: false,
                breadCrumbs: [
                    { text: "Примеры использования", disabled: false }
                ],
                scrolled: false
            }
        },

        computed: {
            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            }
        },

        mounted () {
            this.applyLocale();
        },

        created () {
            window.addEventListener("scroll", this.onScroll);
        },

        destroyed () {
            window.removeEventListener("scroll", this.onScroll);
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.breadCrumbs = [
                    { text: this.$t("tutorials"), disabled: false }
                ];
            },

            /**
             * Обработчик прокрутки экрана
             */
            onScroll () {
                this.scrolled = window.scrollY > 0;
            },

            /**
             * Прокрутка экрана в начало
             */
            scrollToTop () {
                window.scrollTo({
                    top:  0,
                    left: 0,
                    behavior: "smooth"
                });
            }
        }
    }
</script>

<style lang="sass" scoped>
    .tutorials-card
        overflow-y: auto
        max-height: calc(100dvh - 52px)
    .f-left
        float: left
    .f-clear
        clear: both

    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100vh - 128px)
</style>
